import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import {
    getFeedFilterStatusInfo,
    getStatusHint,
    getTargetFunnelWarningMessage
} from '../../service/FeedFiltersHelpers/FeedFiltersHelpers';
import { TestBem } from '../../service/TestBem';
import { GdCampaignPlatform, GdSmartFilterPrimaryStatus, GdSmartFilterTargetFunnel } from '../../typings/graphql-grid';
import { HintInfo, HintInfoType } from '../HintInfo/HintInfo';
import { Shape2, Shape2Icon, Shape2Theme } from '../Shape2/Shape2';

import './FeedFilterStatusCell.css';

export interface FeedFilterStatusCellProps {
    status: GdSmartFilterPrimaryStatus;
    id: string;
    isTextVisible: boolean;
    targetFunnel: GdSmartFilterTargetFunnel;
    campaignPlatform?: GdCampaignPlatform;
}

const BLOCK = 'feed-filter-status-cell';

const statusMods = {
    [GdSmartFilterPrimaryStatus.ACTIVE]: 'active',
    [GdSmartFilterPrimaryStatus.STOPPED]: 'stopped'
};

export class FeedFilterStatusCell extends React.PureComponent<FeedFilterStatusCellProps> {
    render() {
        const { isTextVisible, id, status } = this.props;
        const statusText = getFeedFilterStatusInfo(status);
        const statusMod = statusMods[status];
        const isRenderHint = isTextVisible && status !== GdSmartFilterPrimaryStatus.STOPPED;

        return (
            <div className={Bem.cls(BLOCK)}>
                <div
                    className={classNames(
                        Bem.cls({
                            block: BLOCK,
                            elem: 'status',
                            mods: statusMod ? { [statusMod]: true } : undefined
                        }),
                        TestBem.cls(BLOCK, 'status', { id })
                    )}
                >
                    {this.getStatusIcon()}
                    {isTextVisible && statusText}
                </div>
                {isRenderHint && this.renderHint()}
            </div>
        );
    }

    private getStatusIcon() {
        const { status } = this.props;

        switch (status) {
            case GdSmartFilterPrimaryStatus.ACTIVE:
                return (
                    <Shape2
                        icon={Shape2Icon.statusRunning}
                        theme={Shape2Theme.light}
                        width={12}
                        height={12}
                        cls={Bem.cls(BLOCK, 'icon')}
                    />
                );
            case GdSmartFilterPrimaryStatus.STOPPED:
            default:
                return (
                    <Shape2
                        icon={Shape2Icon.statusEnded}
                        theme={Shape2Theme.light}
                        width={12}
                        height={12}
                        cls={Bem.cls(BLOCK, 'icon')}
                    />
                );
        }
    }

    private renderHint() {
        const { targetFunnel, campaignPlatform } = this.props;
        const hintInfo = getTargetFunnelWarningMessage(targetFunnel, campaignPlatform);
        const statusHint = getStatusHint(targetFunnel, campaignPlatform);

        if (!statusHint || !hintInfo) {
            return null;
        }

        return (
            <div className={Bem.cls(BLOCK, 'hint')}>
                <HintInfo
                    cls={Bem.cls(BLOCK, 'hint-info')}
                    type={HintInfoType.alert}
                    theme={Shape2Theme.light}
                    text={hintInfo}
                    caption={statusHint}
                />
            </div>
        );
    }
}
